module.exports = __webpack_public_path__ + "static/img/14010211.d9a51cc0.png";